module.exports = __webpack_public_path__ + "img/top-5-3.003c2941.jpg";